import { IntlShape } from 'react-intl';

export const getButtonAriaLabel = (intl: IntlShape, isPlaying: boolean, isPause: boolean) => {
    if (isPlaying) {
        return intl.formatMessage({
            id: 'features.legacy-player.105b296a83f9c105355403f3332af50f',
            defaultMessage: 'Pause',
            description: 'Ариа атрибут для кнопки паузы',
        });
    }

    if (isPause) {
        return intl.formatMessage({
            id: 'features.legacy-player.aria-button-label.1b70a40f4fd377bc0f40cefca8241e70',
            defaultMessage: 'Play now',
            description: 'Ариа атрибут для кнопки воспроизведения',
        });
    }
};
